<template>
  <div class="Home">
    <!-- 头部 -->
    <div class="head_box">
      <div class="head">
        <!-- 背景图片 -->
        <img src="@/assets/ico/home.png" alt="" class="BG" />
        <div class="head_content" v-if="userINFO != null">
          <!--头像部分 -->
          <div class="headImg">
            <img
              :src="
                userINFO.user_id_to_data.avatar.length != 0
                  ? userINFO.user_id_to_data.avatar
                  : '	https://www.jszg.com/static/platform/pic/img_headpic.png'
              "
              onerror="	https://www.jszg.com/static/platform/pic/img_headpic.png"
              alt=""
              class="img"
            />
          </div>
          <!-- 右侧文字部分 -->
          <div class="text">
            <!-- 名称部分 -->
            <p class="name">{{ userINFO.user_id_to_data.realname }}</p>
            <!-- 用户信息部分 -->
            <p class="info">
              参与打卡：{{ userINFO.camp_datys }}天
              <span style="margin: 0 1rem">|</span> 发表日记：{{
                userINFO.count
              }}篇
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容部分 -->
    <div class="body_box">
      <el-tabs v-model="activeName" class="Mytab">
        <el-tab-pane label="参与的打卡" name="one">
          <div class="tabItem mycamp" v-if="campFlag">
            <!-- 循环元素部分 -->
            <div
              class="sortTable"
              v-for="(item, index) in mycamp"
              :key="index"
              @click="GoCamp(item.id)"
            >
              <!-- 上部图片部分 -->
              <div class="sortTable_img">
                <img
                  :src="
                    item.img == null
                      ? 'https://fview.5kjs.com/activity/21sign/image/pc/logo.png'
                      : item.img.path
                  "
                  alt=""
                />
              </div>
              <!-- 图下内容部分 -->
              <div class="sortTable_content">
                <div class="sortTable_content_top">
                  <div class="sortTable_content_title">{{ item.name }}</div>
                </div>
                <div class="sortTable_content_bottom">
                  <div class="time">
                    活动时间：{{ item.begin_date }}-{{ item.end_date }}
                  </div>
                  <!-- nowDate代表当前时间，用来判断当前训练营是否结束 -->
                  <div
                    class="status"
                    :style="
                      nowDate > item.end_date.replace(/-/g, '')
                        ? 'background: #CCCCCC'
                        : ''
                    "
                  >
                    {{
                      nowDate > item.end_date.replace(/-/g, "")
                        ? "已结束"
                        : "正在进行"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 空状态 -->
          <div v-else style="width: 100%; padding-bottom: 4.0625rem">
            <div
              style="
                margin: auto;
                width: 18rem;
                height: 18rem;
                text-align: center;
              "
            >
              <img
                style="width: 90%; height: 90%"
                src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                alt=""
              />
              <div style="color: #333333">还没有参与的打卡噢~</div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="打卡日记" name="two">
          <div class="tabItem myshare">
            <div class="item_box" v-if="diaryFlag">
              <shareCard
                v-for="(item, index) in userINFO.list"
                :key="index"
                :myitem="item"
              ></shareCard>
              <MyPaginnation
                @one="onePage()"
                @next="nextPage()"
                :maxPage="totlePage"
                @Mychange="changePage($event)"
              ></MyPaginnation>
            </div>
            <!-- 空状态 -->
            <div v-else style="width: 100%">
              <div
                style="
                  margin: auto;
                  width: 18rem;
                  height: 18rem;
                  text-align: center;
                "
              >
                <img
                  style="width: 90%; height: 90%"
                  src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                  alt=""
                />
                <div style="color: #333333">还没有发表过日记噢~</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// 引入分享卡片组件
import shareCard from "@/components/shareCard.vue";
// 引入分页组件
import MyPaginnation from "@/components/MyPaginnation.vue";
// 引入VUEX
import { mapMutations } from "vuex";
export default {
  name: "home",
  data() {
    return {
      // 滑动栏当前活动的选项
      activeName: "one",
      //   识别码
      user_id_to: this.$route.query.user_id_to,
      //   我参加的训练营
      mycamp: [],
      //   返回的所有信息
      userINFO: null,
      //   分页相关参数
      limit: 5,
      page: 1,
      // 我发布的日记空状态判断
      diaryFlag: false,
      // 我参与的训练营空状态判断
      campFlag: false,
    };
  },
  components: {
    shareCard,
    MyPaginnation,
  },
  methods: {
    // 引入登录函数
    ...mapMutations(["login"]),
    //   获取当前页面需要数据
    getShareList(mypage) {
      //   this.scrollTo();
      let page = this.nowPage;
      if (mypage) {
        page = mypage;
        console.log(page);
      }
      this.$axios
        .get("/getShareList", {
          params: {
            token: localStorage.getItem("token"),
            agency_id: 281,
            camp_id: this.$route.query.camp,
            sort: 2,
            page: this.page,
            limit: this.limit,
            user_id_to: this.user_id_to,
          },
        })
        .then((doc) => {
          this.userINFO = doc;
          console.log(doc);

          if (doc.user_id_to_data == null) {
            this.$router.push({ path: "/*" });
          }

          // 判断是否为空状态  如果list为空则表示发布的日记为空
          if (doc.list != null) {
            this.diaryFlag = true;
          }

          // 清洗数据，选出参加过的训练营
          this.rinse(doc.camp_daka_count);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 清洗数据，选出参加过的训练营
    rinse(data) {
      this.mycamp = [];
      data.forEach((item) => {
        if (item.camp != null) {
          this.mycamp.push(item.camp);
        }
      });

      // 如果数据清洗过后为空，则没有参与的训练营
      if (this.mycamp.length != 0) {
        this.campFlag = true;
      } else {
        this.campFlag = false;
      }
      console.log(this.mycamp);
    },
    // 点击我参与的打卡跳转对应的训练营
    GoCamp(data) {
      this.$router.push({
        path: `/Detail/apply/${data}`,
        query: {
          camp: data,
        },
      });
    },
    // 分页相关函数开始
    // 返回第一页请求
    onePage() {
      if (this.page == 1) {
        this.$message({
          message: "已经是第一页了噢~~~",
          type: "warning",
        });
        return;
      }
      this.page = 1;
      this.getShareList(this.page);
    },
    // 下一页
    nextPage() {
      if (this.page == this.totlePage) {
        this.$message({
          message: "已经是最后一页啦~~~",
          type: "warning",
        });
        return;
      }
      // if()
      this.page++;
      this.getShareList(this.page);
    },
    // 页码跳转
    changePage(page) {
      this.page = page;
      this.getShareList(this.page);
    },
    // 分页相关函数结束
  },
  computed: {
    // 计算当前日期
    nowDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //   let currentdate = `${year}-${month}-${strDate}`;
      let currentdate = `${year}${month}${strDate}`;
      return currentdate;
    },
    // 分页总页数
    totlePage() {
      let totlePage = Math.ceil(this.userINFO.count / this.limit);
      return totlePage;
    },
  },
  mounted() {
    // 请求分享数据
    this.getShareList();
    //判断是否从图文打卡页面过来查看日志的
    if (this.$route.query.type == "back") {
      this.activeName = "two";
    }
  },
  created() {
    //  获取登录token以及科目类编由于涉及多次跨域这里暂时注释，上线之后在请求，
    let url = window.location.origin;
    url = url + "/getInfo";
    this.$axios
      .get(url)
      .then((doc) => {
        if (doc.token != null) {
          localStorage.setItem("token", doc.token);
          localStorage.setItem("agency_id", doc.agency_id);
          this.login(doc);
        } else {
          localStorage.setItem("agency_id", doc.agency_id);
          localStorage.removeItem("token");
          this.login(doc);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="less" scoped>
.Home {
  // 头部部分
  .head_box {
    width: 100%;
    height: 9.9375rem;
    .head {
      position: relative;
      width: 100%;
      height: 9.9375rem;
      color: red;
      //背景图片
      .BG {
        position: absolute;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 0;
      }
      //内容部分
      .head_content {
        margin: auto;
        position: relative;
        z-index: 1;
        height: 100%;
        max-width: 80rem;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        // 用户头像部分
        .headImg {
          width: 7.8125rem;
          height: 7.8125rem;
          border-radius: 50%;
          padding: 5px;
          background-color: #fff;
          overflow: hidden;
          .img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        // 右侧文字部分
        .text {
          margin-left: 3.125rem;
          .name {
            font-size: 1.375rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
          }
          .info {
            margin-top: 1.25rem;
            font-size: 1rem;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #ffffff;
          }
        }
      }
    }
  }

  //   下方滑动栏部分
  .body_box {
    max-width: 80rem;
    margin: auto;
    /deep/ .Mytab {
      margin-top: 2.5rem;
      //   修改组件的样式
      .el-tabs__header {
        .el-tabs__nav-wrap::after {
          height: 0.0625rem;
          background: #dddddd;
        }
        .el-tabs__active-bar {
          background-color: #ff0000;
        }
        .el-tabs__item.is-active {
          font-size: 1.125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        .el-tabs__item {
          font-size: 1.125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
      //   tab栏的公用样式
      .tabItem {
        margin-top: 0.625rem;
      }
      //   我参与的训练营部分
      .mycamp {
        padding-bottom: 3.7rem;
        overflow: hidden;
        .sortTable {
          float: left;
          cursor: pointer;
          margin: 2.125rem 2.125rem 0 0;
          box-sizing: border-box;
          padding: 1.15625rem 1.1125rem 1.09375rem 1.1375rem;
          width: 17.5625rem;
          // height: 21.8125rem;
          background: #ffffff;
          box-shadow: 0px 0.1875rem 1rem 0px rgba(0, 0, 0, 0.08);
          //   上部图片部分
          .sortTable_img {
            // width: 15.3125rem;
            width: 100%;
            height: 10.875rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          //   图下内容部分
          .sortTable_content {
            // margin-top: 1.5rem;
            .sortTable_content_top {
              margin-bottom: 2.75rem;
              box-sizing: border-box;
              padding-top: 1.5rem;
              //   height: 6.75rem;
              display: flex;
              flex-direction: column;
              .sortTable_content_title {
                font-size: 1rem;
                font-family: "Microsoft YaHei";
                font-weight: 400;
                color: #545e64;

                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .sortTable_content_bottom {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              box-sizing: border-box;
              margin-top: 1.125rem;
              width: 100%;
              border-radius: 0.25rem;
              div {
                font-size: 0.875rem;
                font-family: "Microsoft YaHei";
                font-weight: 400;
                color: #4b4b5b;
              }
              .time {
                font-size: 0.75rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #9b9b9b;
              }
              .status {
                padding: 0.375rem 0.625rem;
                margin-top: 0.75rem;
                background: #26d3bc;
                border-radius: 0.9375rem;
                font-size: 0.75rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
              }
            }
          }
        }
      }
      //  我的打卡日记部分
      .myshare {
        padding-bottom: 4.0625rem;
        .item_box {
          max-width: 51.25rem;
          .sharCard {
            width: 51.25rem;
          }
        }
      }
    }
  }
}
</style>